<template lang="html">
<div class="keyword-container" v-if="hasPermitPacks() || hasGuestParking()">
  <search :textProp="textProp"
          v-bind:lookup="['users', 'parkings', 'products']"
          v-on:query="autocompleteSelected">
    <template slot="inner-item" slot-scope="props">
      <div v-if="props.item.type !== undefined" class="type type--pack">
        <i class="type-icon icon-product-black"></i>
        <div>
          <div class="row">
            <span class="title">{{props.item.name}}</span>
            <span class="disabled">{{props.item.issued}} / {{props.item.total}}</span>
          </div>
          <div class="row sub-row disabled text-overflow">{{props.item.address}}</div>
        </div>
      </div>
      <div v-else-if="props.item.startTime" class="type type--parkings">
        <i class="type-icon icon-parking-clock-black"></i>
        <div>
          <div class="row">
            <span class="title">{{props.item.vehicleReg}}</span>
            <span class="disabled">{{props.item.comment}}</span>
          </div>
          <div class="row sub-row disabled">
            <span>{{props.item.startTime | moment}} - <span v-if="props.item.endTime">{{props.item.endTime | moment}}</span></span>
            <span class="orange" v-if="props.item.price">{{props.item.price | price}}&euro;</span>
          </div>
        </div>
      </div>
      <div v-else class="type type--users">
        <i class="type-icon icon-users-black"></i>
        <div>
          <div class="row">
            <span class="text-overflow">{{props.item.name}}</span>
            <span class="disabled" v-if="props.item.permitsCount">{{props.item.permitsCount}}</span>
          </div>
          <div class="row sub-row disabled text-overflow">{{ $t('common.phone') }}:&nbsp;{{props.item.mobile | phone(props.item.mobileCountry)}}</div>
        </div>
      </div>
    </template>
  </search>
</div>
</template>

<script>
import moment from 'moment';
import Search from 'common/Search';
import { format } from 'libphonenumber-js';

export default {
  components: {
    Search,
  },
  props: ['lookup', 'limit'],
  data() {
    return {
      query: '',
      search: null,
    };
  },
  methods: {
    autocompleteSelected(q) {
      if (q.item.type !== undefined) {
        this.$router.push({ name: 'product', params: { id: q.item.id }, query: { keyword: q.query } });
      } else if (q.item.startTime !== undefined) {
        this.$router.push({ name: 'parking', params: { id: q.item.id }, query: { keyword: q.query } });
      } else {
        this.$router.push({ name: 'user', params: { id: q.item.id }, query: { keyword: q.query } });
      }
    },
    textProp(item) {
      if (item.vehicleReg) {
        return item.vehicleReg;
      }
      return item.name;
    },
  },
  filters: {
    moment(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    price(price) {
      return price;
    },
    phone(phone, country) {
      return format({ country, phone }, 'International_plaintext');
    },
  },
};
</script>

<style lang="scss">
@import '~styles/blocks/keyword-filter.scss';

.autocomplete {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  &__list {
    &-item {
      flex-direction: column;
      line-height: 1.7rem !important;
      + .autocomplete__list-item {
        border-top: 1px solid #e6ecf1;
      }
      .type {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
        .type-icon {
          display: inline-block;
          width: 32px;
          height: 32px;
          background-size: contain;
          margin-right: 10px;

          + div {
            width: 100%;
          }
        }
        .row {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          &.sub-row {
            font-size: 14px;
          }
        }
        .text-overflow {
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 245px;
          white-space: nowrap;
          &.sub-row {
            max-width: 350px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tenant-dashboard/KeywordFilter.vue